export enum PhoneNumbersLabels {
  Support = '(404) 205-8882',
}

export enum PhoneNumbers {
  Support = '404-205-8882',
}
